import { render, staticRenderFns } from "./BusinessProcessMessages.vue?vue&type=template&id=151e883b&"
import script from "./BusinessProcessMessages.vue?vue&type=script&lang=js&"
export * from "./BusinessProcessMessages.vue?vue&type=script&lang=js&"
import style0 from "./BusinessProcessMessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCardSection,QBanner,QIcon} from 'quasar'
component.options.components = Object.assign({QCardSection,QBanner,QIcon}, component.options.components || {})
